<script>
let table = 'usuarios_domicilios', 
    loadUpAPI = ('ui/userlinked/' + table);

    import _ from 'lodash'
    import axios from 'axios'
    import mobiscroll from '@mobiscroll/javascript'
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import textualAddress from '../daniel/textual-address.vue';

    export default {
	    components: { textualAddress },
        name: 'DeliveryAddress',

        props: {
            readonly: {
                type: Boolean,
                default: false
            }
        },

        computed: {

            ...mapGetters({
                cartGetConfigs: 'cartGetConfigs',
                cartGetAddressIsValid: 'cartGetAddressIsValid',
                catalogosGetConfigs: 'catalogosGetConfigs',
                form: 'cartGetAddress',
            }),

            selectedAddress(){
                return _.find(this.index, (item) => {
                    return (parseInt(this.selectedAddressId) == parseInt(item.id))
                })
            },

            deliveryObject(){
                return {
                    normal: {
                        price: parseFloat(_.find(this.catalogosGetConfigs, {clave: 'app_envio_estandar_costo'}).valor),
                        desc: _.find(this.catalogosGetConfigs, {clave: 'app_envio_estandar_desc'}).valor,
                    },
                    express: {
                        price: parseFloat(_.find(this.catalogosGetConfigs, {clave: 'app_envio_express_costo'}).valor),
                        desc: _.find(this.catalogosGetConfigs, {clave: 'app_envio_express_desc'}).valor,
                    }
                }
            }
        },

        data: () => {
            return {
                isLoading: false,
                selectedAddressId: false,
                index: [],
                asides: {
                    estados: [],
                    municipios: [],
                }
            }
        },

        methods: {
            ...mapMutations(['cartSetValidAddress']),
            ...mapActions(['cartAddNewAddresData', 'cartUpdateConfigs']),
            getTextual(){
                try {
                    let found = this.selectedAddress,
                        ret = [];
                    ret.push(found.calle)
                    if(!!found.numero_interior)
                        ret.push(`#${found.numero} Int ${found.numero_interior}.`)
                    else
                        ret.push(`#${found.numero}.`)
                    ret.push(`Col. ${found.colonia}.`)
                    ret.push(`${found.asides.municipio},`)
                    ret.push(`${found.asides.estado}.`)
                    if(!!found.referencia)
                        ret.push(`(Referencia: ${found.referencia})`)
                    return ret.join(' ')
                } catch(e){
                    console.error('Error al localizar el domicilio especificado', {found, ret})
                    return null
                }
            },
            async setupOrder(){
                let data2config = {
                    usuarios_domicilios_id: this.selectedAddressId,
                    // address:
                    address: this.getTextual(),
                    shipping: (this.deliveryObject.express.price == this.form.envio) ? 'Express' : 'Estandar',
                    shipping_cost: this.form.envio
                }
                console.debug('setupOrder', data2config)
                await this.cartUpdateConfigs(data2config)
            },
            async loadUp(){
                try {
                    let response = await axios.get(loadUpAPI)

                    console.log("response", response)

                    // ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
                    if (response.msg) {
                        mobiscroll.snackbar({
                            display: 'top',
                            theme: 'ios',
                            message: response.msg,
                            color: response.class,
                            duration: 7000
                        })
                    }
                    if(response.status){
                        this.index = response.data;
                        if(typeof response.asides == 'object') this.asides = response.asides
                    }
                } catch(e) {
                    console.error(e)
                    mobiscroll.snackbar({
                        display: 'top',
                        theme: 'ios',
                        message: 'Ocurrió un error obteniendo la respuesta de lectura: ' + e,
                        color: 'warning',
                        duration: 7000
                    })
                }
            },
            async triggerAddData(){
                try {
                    if(this.selectedAddressId == 'new'){
                        const response = await this.cartAddNewAddresData()
                        if(response.status){
                            await this.loadUp()
                            this.selectedAddressId = response.data.id
                            await this.setupOrder()
                        } else {
                            throw 'Error guardando el domicilio';
                        }
                        return response.status
                    } else {
                        await this.setupOrder()
                        return true
                    }
                } catch(e){
                    console.error(e)
                }
            },
            async fetchMunic(){
                try {
                    let response = await axios.get('ui/getmunibyid/' + this.form.estados_id)
                    if(response.status){
                        this.asides.municipios = response.data
                    }
                } catch(e) {
                    console.error(e)
                    mobiscroll.snackbar({
                        display: 'top',
                        theme: 'ios',
                        message: 'Ocurrió un error obteniendo la respuesta: ' + e,
                        color: 'warning',
                        duration: 7000
                    })
                }
            },
            defineConfigStatus(){
                // this.cartSetValidAddress((parseInt(this.selectedAddressId) && parseInt(this.form.envio) && this.form.envio)?true:false)
                this.cartGetConfigs.usuarios_domicilios_id = this.selectedAddressId
            }
        },

        async mounted(){
            this.isLoading = true;
            try {
                await Promise.all([ this.loadUp()])
                if(!!this.form.estados_id)
                    await this.fetchMunic()
            } catch(e){
                console.error(e)
            }
            this.defineConfigStatus()
            this.isLoading = false
        },

        watch: {
            'form.envio'(){
                this.defineConfigStatus()
            },
            selectedAddressId(){
                this.defineConfigStatus()
            },
            'form.estados_id'(){
                this.fetchMunic()
            }
        }
    }
</script>

<template>
    <div id="deliveryAddress" v-if="!isLoading">
        <h5>Domicilio de entrega</h5>

        <template v-if="!readonly">
            <b-form-radio v-for="address in index" :key="address.id" v-model="selectedAddressId" name="usuariosDomcilioID" :value="address.id">
                <textual-address :address="address" />
            </b-form-radio>

            <b-form-radio v-model="selectedAddressId" name="usuariosDomcilioID" value="new" class="add-new" >
                <strong>
                Nuevo domicilio
                </strong>
            </b-form-radio>
        </template>

        <template v-else>
            <textual-address :address="selectedAddress"/>
        </template>

        <b-form @submit="triggerAddData($event)" class="mt-2">

            <template v-if="selectedAddressId == 'new'">
                <b-row class="mt-3">
                    <b-col sm="12" md="6">
                        <b-form-group label="Calle" label-for="formCalle">
                            <b-form-input id="formCalle" v-model="form.calle" required :readonly="readonly"/>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Número" label-for="formNumero">
                            <b-form-input id="formNumero" v-model="form.numero" required :readonly="readonly"/>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group label="Número interior" label-for="formNumeroInterior">
                            <b-form-input id="formNumeroInterior" v-model="form.numero_interior" required :readonly="readonly"/>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>

                    <b-col>
                        <b-form-group label="Estado" label-for="formEstado">
                            <b-form-select v-model="form.estados_id" label="Estado" id="formEstado" :disabled="readonly">
                                <b-form-select-option :value="null">Selecciona un estado</b-form-select-option>
                                <b-form-select-option v-for="estado in asides.estados" :value="estado.value" :key="estado.value">
                                    {{estado.label}}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    
                    <b-col>
                        <b-form-group label="Municipio" label-for="formMuni">
                            <b-form-select v-model="form.municipios_id" label="Estado" id="formMuni" :disabled="!form.estados_id || readonly">
                                <b-form-select-option :value="null">Selecciona un municipio</b-form-select-option>
                                <b-form-select-option v-for="muni in asides.municipios" :value="muni.id" :key="muni.id">
                                    {{muni.municipio}}
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group label="Colonia" label-for="formColonia">
                            <b-form-input id="formColonia" v-model="form.colonia" required  :readonly="readonly"/>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group label="Codigo Postal" label-for="formCPostal">
                            <b-form-input id="formCPostal" v-model="form.codigo_postal" required  :readonly="readonly"/>
                        </b-form-group>
                    </b-col>

                </b-row>

                <b-row>
                    <b-col>
                        <b-form-group label="Referencia" label-for="formReferencia">
                            <b-form-textarea id="formReferencia" v-model="form.referencia" required  :readonly="readonly"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>

            <h5 class="ui-separate" v-if="!readonly">Selecciona el método de envío</h5>

            <b-row>
                <b-col>
                    <b-form-group>
                        <b-form-radio v-model="form.envio" name="form-envio" :value="deliveryObject.normal.price"  :disabled="readonly" v-if="!readonly || form.envio == deliveryObject.normal.price">
                            <strong>Envío normal {{deliveryObject.normal.price | currency}}</strong> <br>
                            <i>{{deliveryObject.normal.desc}} </i>
                        </b-form-radio>
                        <b-form-radio v-model="form.envio" name="form-envio" :value="deliveryObject.express.price"  :disabled="readonly" v-if="!readonly || form.envio == deliveryObject.express.price">
                            <strong>Envío express {{deliveryObject.express.price | currency}}</strong> <br>
                            <i>{{deliveryObject.express.desc}} </i>
                        </b-form-radio>
                    </b-form-group>
                </b-col>
            </b-row>

        </b-form>
    </div>
    <div v-else>
        <h5>Procesando...</h5>
    </div>
</template>

<style lang="less">
    #deliveryAddress {
        h5 {
            margin-bottom: 1em;
        }
        .add-new {
            color: var(--primary);
        }
        .custom-radio {
            margin: 0.5em auto;
        }
        .ui-separate {
            margin-top: 2em;
        }
    }
</style>